// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/js/dist/collapse.js"

import { applyHomepageLanguageRedirect } from "./src/utils/preferred-language"

export const onRouteUpdate = ({ location }) => {
  applyHomepageLanguageRedirect(location)
  if (typeof requestAnimationFrame === `function`) {
    requestAnimationFrame(() => applyHomepageLanguageRedirect(location))
  }
}
